import type { ReactElement, PropsWithChildren } from 'react';
import { DialogTitle } from '@florencelabs/modal-2';
import { useEffect, useRef } from 'react';

interface DecisionTreeHeaderProps extends PropsWithChildren {
  /** When true, focuses the header on mount (for step navigation a11y) */
  autoFocus?: boolean;
}

export const DecisionTreeHeader = ({
  children,
  autoFocus = false,
}: DecisionTreeHeaderProps): ReactElement => {
  const headingRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!autoFocus) return;

    const frameId = requestAnimationFrame(() => {
      headingRef.current?.focus();
    });

    return () => {
      cancelAnimationFrame(frameId);
    };
  }, [autoFocus]);

  return (
    <DialogTitle
      className={
        'pb-8 text-display-medium font-semibold outline-none lgTablet:text-display-large lgTablet:font-semibold'
      }
      data-testid={'decision-tree-header'}
    >
      <span ref={headingRef} tabIndex={-1} className={'outline-none'}>
        {children}
      </span>
    </DialogTitle>
  );
};
